






















































































import Vue, { PropType } from 'vue';
import { IABTest, IABTestModalProp } from '@/store/types';
import * as actions from '@/store/action-types';
import ABTestFinishModal from '@/components/Cancellation/ABTests/ABTestFinishModal.vue';

export default Vue.extend({
  name: 'ABTestInfo',
  components: {
    ABTestFinishModal,
  },
  props: {
    context: String,
    showRename: Boolean,
    currentABTest: {
      type: Object as PropType<IABTest>,
    },
    abTest: {
      type: Object as PropType<IABTestModalProp>,
    },
  },
  data() {
    return {
      showABTestFinish: false as boolean,
    };
  },
  created() {
    this.$store.dispatch(actions.FETCH_AB_SESSION_COUNTS);
  },
  computed: {
    sessionCount() {
      return this.$store.state.abSessionCounts?.[this.currentABTest._id] || 0;
    },
    titleClasses() {
      return this.context === 'resultsPage' ? 'title' : 'text-xl font-bold text-brand-black';
    },
    segmentsActivated() {
      return this.currentABTest.segments?.reduce((acc, segmentId) => {
        const segment = this.$store.state.segments[segmentId];
        const segmentEnabled = segment?.enabled && segment.activeBlueprint;
        return acc && segmentEnabled;
      }, true);
    },
  },
  methods: {
    closeABTestFinish() {
      this.showABTestFinish = false;
    },
    handleABTestFinish(abTest: IABTest) {
      this.abTest.selectedABTest = abTest;
      this.abTest.winner = '';
      this.showABTestFinish = true;
    },
    handleABTestStart() {
      if (this.currentABTest._id) {
        this.$emit('update', { enabled: !this.currentABTest.enabled });
        this.$emit('update', { startedAt: new Date() });
        this.$set(this.currentABTest, 'enabled', !this.currentABTest.enabled);
        this.$set(this.currentABTest, 'startedAt', new Date());
        this.$store.dispatch(actions.UPDATE_AB_TEST, {
          id: this.currentABTest._id,
          reload: false,
          data: {
            startedAt: this.currentABTest.startedAt,
            enabled: this.currentABTest.enabled,
          },
        });
        this.$message({
          message: `A/B Test started`,
          type: 'success',
          duration: 2000,
        });
      }
    },
    handleEnableDisableABTest() {
      if (this.currentABTest._id) {
        this.$emit('update', { enabled: !this.currentABTest.enabled });
        this.$set(this.currentABTest, 'enabled', !this.currentABTest.enabled);
        this.$store.dispatch(actions.UPDATE_AB_TEST, {
          id: this.currentABTest._id,
          reload: false,
          data: {
            enabled: this.currentABTest.enabled,
          },
        });
        this.$message({
          message: `A/B Test ${this.currentABTest.enabled ? 'resumed' : 'paused'}`,
          type: 'success',
          duration: 2000,
        });
      }
    },
    showABTestResults() {
      if (this.currentABTest._id) {
        this.$router.push({ name: 'flows', params: { view: 'abtests', id: this.currentABTest._id } });
      }
    },
  },
});
